export const FACADES = ["north", "south", "east", "west"];
